const initialState = {
  amount: '',
  memo: '',
  errors: [],
  ui: {
    show: false,
    is_submitting: false
  }
}

export default function addBalanceForm(state=initialState, action){
  switch(action.type){
    case "UPDATE_ADD_BALANCE_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
      }
    case "UPDATE_ADD_BALANCE_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "BEGIN_SUBMIT_ADD_BALANCE":
      return {
        ...state,
        ui: { 
          ...state.ui,
          is_submitting: true }
      };
    case "SUCCESS_SUBMIT_ADD_BALANCE":
      return {
        ...initialState,
      };
    case "FAILED_SUBMIT_ADD_BALANCE":
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          is_submitting: false,
        }
      };
    case "RESET_ADD_BALANCE_FORM":
      return initialState;
    default: 
      return state
  }
}